exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".img-list{padding:1em}.img-list .img-item{padding:1em 0}\n", ""]);

// exports
